import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';
import BackToTopButton from '../ui/BackToTopButton';
import ScrollToTop from './ScrollToTop';
import { useLanguage } from '../../i18n/LanguageContext';
import { useLocation } from 'react-router-dom';
import BackButton from '../ui/BackButton';

const Main = styled.main`
  min-height: 100vh;
  padding-top: 70px; /* Spazio per l'header fisso */
`;

const BannerStrip = styled.div`
  background: linear-gradient(90deg, #121212 0%, #2d2d2d 100%);
  color: #ffffff;
  text-align: center;
  padding: 8px 10px;
  font-size: clamp(8px, 1.2vw, 12px);
  font-weight: 700;
  font-family: 'Montserrat', 'Arial', sans-serif;
  letter-spacing: 0.3px;
  position: fixed;
  top: 70px; /* Posizione appena sotto l'header */
  width: 100%;
  z-index: 998;
  text-transform: uppercase;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  white-space: nowrap; /* Prevent text wrapping */
  overflow-x: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.2;
  
  /* Separators */
  .separator {
    display: inline-block;
    margin: 0 clamp(2px, 0.3vw, 8px);
    color: #004744;
    font-weight: 900;
  }
  
  /* Highlight words */
  span {
    color: #004744;
    text-shadow: 0 0 5px #004744;
    position: relative;
    padding: 0 2px;
    
    &:after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: #004744;
      transform: scaleX(0);
      transition: transform 0.3s ease-in-out;
    }
    
    &:hover:after {
      transform: scaleX(1);
    }
  }
  
  @media (max-width: 768px) {
    padding: 6px 5px;
    font-size: 10px;
    .separator {
      margin: 0 2px;
    }
  }
`;

const TopActions = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  margin-top: 16px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { t } = useLanguage();
  const location = useLocation();
  const isServicesRoute = location.pathname.startsWith('/services');
  
  return (
    <>
      <ScrollToTop />
      <Header />
      <BannerStrip>
        {t('layout.banner.part1')} <span>{t('layout.banner.part2')}</span> {t('layout.banner.part3')}
        <span className="separator">|</span> 
        <span>{t('layout.banner.part4')}</span> {t('layout.banner.part5')}
        <span className="separator">|</span> 
        {t('layout.banner.part6')} <span>{t('layout.banner.part7')}</span> {t('layout.banner.part8')}
      </BannerStrip>
      <Main style={{ paddingTop: '110px' }}>
        {isServicesRoute && (
          <TopActions>
            <BackButton />
          </TopActions>
        )}
        {children}
      </Main>
      <Footer />
      <BackToTopButton />
    </>
  );
};

export default Layout; 
